<template>
  <a-tree
    v-model="value"
    checkable
    :expanded-keys="expandedKeys"
    :auto-expand-parent="autoExpandParent"
    :defaultCheckedKeys="defaultOptions"
    :tree-data="options"
    @expand="onExpand"
    @check="onCheck"
    :selectable="false"
    :disabled="disabled"
  />
</template>
<script>
import Tree from 'ant-design-vue/lib/tree' // for js
import 'ant-design-vue/lib/tree/style/index.css'

export default {
  inheritAttrs: false,
  components: {
    'a-tree': Tree,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultOptions: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      expandedKeys: [],
      autoExpandParent: false,
    }
  },
  methods: {
    onCheck(checkedKeys) {
      //console.log(checkedKeys, this.value)
      this.$emit('change', checkedKeys)
    },
    onExpand(expandedKeys) {
      //console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
  },
}
</script>
